﻿import { useState } from "react";
import { Modal, Button, Card, Form, Row, Col } from "react-bootstrap";
import Select from "react-select";
import { useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";

import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";

import classes from "./CodesMovements.module.scss";
import Codes from "./Codes";

import { useExistence } from "@/hooks/products/useExistence";
import Fetching from "@/components/Fetching/Fetching";
import Applications from "./Applications";

const CodesMovements = ({ type }) => {
	const { option, product_id, inventory_id } = useParams();
	const navigate = useNavigate();

	const { filter } = useSelector((state) => state.auth);
	const { estate_parent_id, estate_id } = filter;

	const [showOC, setShowOC] = useState(type === "OC" ? true : false);
	const [showSale, setShowSale] = useState(type === "Sale" ? true : false);
	const [showDelivery, setShowDelivery] = useState(type === "Delivery" ? true : false);
	const [showInventory, setShowInventory] = useState(type === "Inventory" || type === "Product" ? true : false);
	const [showApplication, setShowApplication] = useState(type === "Inventory" || type === "Product" ? true : false);

	const [applyFilterCode, setApplyFilterCode] = useState("");
	const [applyFilterType, setApplyFilterType] = useState("general");

	const [result, setResult] = useState([]);

	const { data, isLoading } = useExistence({ type, product_id, inventory_id, option, estate_parent_id, estate_id });

	const handleClose = () => {
		setResult([]);

		if (type === "Inventory") {
			navigate("/inventario");
			return;
		}
		navigate(-1);
	};

	const types = [
		{ value: "general", label: "General" },
		{ value: "detail", label: "Detalle" },
	];

	return (
		<Modal
			show={option === "movimientos" && product_id ? true : false}
			onHide={handleClose}
			backdrop="static"
			keyboard={false}
			dialogClassName="modal-size-lg"
		>
			<div>
				<Modal.Header closeButton>
					<Modal.Title style={{ fontSize: "1em" }}>Resumen</Modal.Title>
				</Modal.Header>
				<Modal.Body style={{ padding: "15px 11px" }}>
					{isLoading ? (
						<Fetching topMargin={"0px"} />
					) : (
						<>
							<div style={{ marginBottom: "10px" }}>
								<Form>
									<Row>
										<Col>
											<Form.Label style={{ fontSize: "0.8em" }}>Código</Form.Label>
											<Form.Control type="text" value={applyFilterCode} onChange={(e) => setApplyFilterCode(e.target.value)} />
										</Col>
										<Col>
											<Form.Label style={{ fontSize: "0.8em" }}>Tipo de Vista</Form.Label>
											<Select
												value={types.find((type) => type.value === applyFilterType)}
												placeholder={<div>Seleccione</div>}
												options={types}
												onChange={(value) => setApplyFilterType(value.value)}
												components={{ NoOptionsMessage }}
											/>
										</Col>
									</Row>
								</Form>
							</div>

							<Card className={classes.cardItem} style={{ display: "none" }}>
								<Card.Header onClick={() => setShowOC(!showOC)}>Ordenes de Compra</Card.Header>
								<div className={`${classes.cardBody} ${showOC && classes.show}`}>
									<Card.Body>1</Card.Body>
								</div>
							</Card>

							<Card className={classes.cardItem} style={{ display: "none" }}>
								<Card.Header onClick={() => setShowSale(!showSale)}>Facturas</Card.Header>
								<div className={`${classes.cardBody} ${showSale && classes.show}`}>
									<Card.Body>2</Card.Body>
								</div>
							</Card>

							<Card className={classes.cardItem} style={{ display: "none" }}>
								<Card.Header onClick={() => setShowDelivery(!showDelivery)}>Guías de Despacho</Card.Header>
								<div className={`${classes.cardBody} ${showDelivery && classes.show}`}>
									<Card.Body>3</Card.Body>
								</div>
							</Card>

							<Card className={classes.cardItem} style={{ display: "none" }}>
								<Card.Header className={`${type === "Inventory" && classes.active}`} onClick={() => setShowInventory(!showInventory)}>
									Inventario
								</Card.Header>
								<div className={`${classes.cardBody} ${showInventory && classes.show}`}>
									<Card.Body className={`${classes.bodyContent}`}>
										<Codes data={data} applyFilterCode={applyFilterCode} applyFilterType={applyFilterType} />
									</Card.Body>
								</div>
							</Card>

							<Card className={classes.cardItem}>
								<Card.Header onClick={() => setShowApplication(!showApplication)}>Movimientos</Card.Header>
								<div className={`${classes.cardBody} ${showApplication && classes.show}`}>
									<Card.Body className={`${classes.bodyContent}`}>
										<Applications
											data={data}
											applyFilterCode={applyFilterCode}
											applyFilterType={applyFilterType}
											result={result}
											setResult={setResult}
										/>
									</Card.Body>
								</div>
							</Card>
						</>
					)}
				</Modal.Body>
				<Modal.Footer>
					<Button style={{ fontSize: "0.8em" }} variant="danger" onClick={() => handleClose()}>
						CERRAR
					</Button>
				</Modal.Footer>
			</div>
		</Modal>
	);
};

export default CodesMovements;
